import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Flex } from "@jsq/ds/core";
import { User } from "~/types/user";
import { getRedirectPath, isDataVaultUser, isDataVaultAdmin } from "~/utils/userRoles";
import BulkUpload from "./BulkUpload";
import CustomFields from "./CustomFields";
import Entities from "./Entities";
import * as styles from "./styles_vanilla.css";

interface Props {
  currentUser: User;
}

const DataVault: React.FC<Props> = ({ currentUser }) => {
  const { pathname } = useLocation();

  if (!isDataVaultUser(currentUser.roles)) {
    return <Redirect to={getRedirectPath(currentUser)} />;
  }

  return (
    <Flex data-testid="data-vault-root" flexDirection="row" className={styles.wrapperContainer}>
      <Flex flexDirection="column" className={styles.contentWrapper}>
        <div className={styles.contentArea} data-testid="data-vault-content-area">
          <Switch>
            <Route path="/data-vault/custom-fields">
              {isDataVaultAdmin(currentUser.roles) ? (
                <CustomFields isActive={pathname.includes("/custom-fields")} />
              ) : (
                <Redirect to="/data-vault/entities" />
              )}
            </Route>
            <Route path="/data-vault/entities/bulk-upload">
              <BulkUpload />
            </Route>
            <Route path="/data-vault/entities">
              <Entities />
            </Route>
            <Route path="/data-vault">
              <Redirect
                to={
                  isDataVaultAdmin(currentUser.roles)
                    ? "/data-vault/custom-fields"
                    : "/data-vault/entities"
                }
              />
            </Route>
          </Switch>
        </div>
      </Flex>
    </Flex>
  );
};

export default DataVault;
export { DataVault };
